import React from 'react';
import { useParams } from 'react-router-dom';

import { AllRegistrationScreenParams } from '../../../../utils/navigation';

import SoknadBase from './soknadBase';
import { RegistrationBase } from './registrationBase';

// TODO: Remove use of common base component when soknad and registration are fully separated
const Base = () => {
  const { soknadSteg } = useParams<AllRegistrationScreenParams>();

  const isSoknad = soknadSteg !== undefined;

  if (isSoknad) {
    return <SoknadBase />;
  }

  return <RegistrationBase />;
};

export default Base;
